export enum HashVersion {
	V1 = '1',
	V2 = '2',
	CHAT_ANTHROPIC = 'chatAnthropic'
}
